module.exports = __webpack_public_path__ + "static/media/check.45efb186.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/check.svg
// module id = 2918
// module chunks = 0